import { MenuDistributionSettingsBuilder } from "./menu.distribution.builder";
import { MenuDistributionType } from './menu.distribution.enum';

export class MenuDistributionSettings {
  public readonly type: MenuDistributionType;
  public readonly labels: string[];
  constructor(builder: MenuDistributionSettingsBuilder) {
    this.type = builder.type;
    this.labels = builder.labels;
  }
}
